if (!customElements.get('products-slider')) {
  class ProductsSlider extends customElements.get('slider-default') {
    constructor() {
      super();

      this.cardTextSlide = this.querySelector('.card-text')?.parentElement;

      if (!this.cardTextSlide) return;

      this.cardTextSlide.remove();

      this.setCardTextPosition();
      this.removeAllCardTextSlides();
      this.addCardTextSlides();

      breakpointDesktop.addEventListener('change', (e) => {
        this.removeAllCardTextSlides();
        this.addCardTextSlides();
      });
    }

    setCardTextPosition() {
      this.cardTextPosition = breakpointDesktop.matches ? 6 : 4;
    }

    removeAllCardTextSlides() {
      const cardTextElements = this.querySelectorAll('.card-text');

      cardTextElements.forEach((cardText) => cardText.parentElement.remove());
      this.slider.update();
    }

    addCardTextSlides() {
      this.setCardTextPosition();

      for (let index = 0; index < this.slider.slides.length; index++) {
        index = index + this.cardTextPosition - 2;
        const slideBefore = this.slider.slides[index];

        if (!slideBefore) break;

        slideBefore.insertAdjacentHTML(
          'afterend',
          this.cardTextSlide.outerHTML,
        );
      }

      this.slider.update();
    }
  }

  customElements.define('products-slider', ProductsSlider);
}
